import { Injectable } from '@angular/core';
import { Subject } from 'rxjs';

@Injectable()
export class SidebarService {
  private sidebarAnimationProgressSource$ = new Subject<void>();
  private sidebarToggledSource$ = new Subject<void>();

  sidebarAnimationProgress$ = this.sidebarAnimationProgressSource$.asObservable();
  sidebarToggled$ = this.sidebarToggledSource$.asObservable();

  private interval;
  private timeout;
  private animateDurationInMs = 300;

  sidebarAnimationStart() {
    if (this.timeout) clearTimeout(this.timeout);
    if (this.interval) clearInterval(this.interval);
    this.interval = setInterval(() => this.sidebarAnimationProgressSource$.next());
    this.timeout = setTimeout(() => clearInterval(this.interval), this.animateDurationInMs);
  }

  sidebarToggled() {
    this.sidebarToggledSource$.next();
  }
}
